var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_648_5836)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.1382 10.2303C20.1382 9.55056 20.0831 8.86711 19.9655 8.19836H10.5332V12.0492H15.9346C15.7105 13.2911 14.9903 14.3898 13.9357 15.0879V17.5866H17.1582C19.0506 15.8449 20.1382 13.2728 20.1382 10.2303Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5329 20.0006C13.23 20.0006 15.5045 19.1151 17.1616 17.5865L13.9391 15.0879C13.0426 15.6979 11.8851 16.0433 10.5366 16.0433C7.92775 16.0433 5.71573 14.2832 4.92205 11.9169H1.59668V14.4927C3.29427 17.8695 6.75193 20.0006 10.5329 20.0006Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.91865 11.9169C4.49977 10.6749 4.49977 9.33008 4.91865 8.08811V5.51233H1.59695C0.178619 8.33798 0.178619 11.667 1.59695 14.4927L4.91865 11.9169Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5329 3.95805C11.9586 3.936 13.3365 4.47247 14.369 5.45722L17.2241 2.60218C15.4163 0.904587 13.0169 -0.0287217 10.5329 0.000673888C6.75192 0.000673888 3.29427 2.13185 1.59668 5.51234L4.91838 8.08813C5.70838 5.71811 7.92407 3.95805 10.5329 3.95805Z",
    fill: "#EA4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_648_5836"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.333008)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/Google.b77be882571877d86a874ab1abc0d09b.svg";
export { ForwardRef as ReactComponent };